import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	TabContent, TabPane, Nav, NavItem, NavLink,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import classnames from 'classnames';
import $ from 'jquery';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import FileBase64 from 'react-file-base64';
import Loader from '../../Loader';
import StudentPage from '../../views/StudentPage';
const GLOBAL = require('../../Globals');

class EditStudent extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			stdcat: '',
			_message: '',
			alertClass: '',
			other: '',
			others: '',
			academic: [],
			posts: [],
			secs: [],
			caste: [],
			communi: [],
			cate: [],
			reli: [],
			rcod: [],
			de: [],
			hname: [],
			room: [],
			country: '',
			region: '',
			acyear: '',
			regno: '',
			joindate: '',
			cls: '',
			section: '',
			ano: '',
			stdname: '',
			dob: '',
			gender: '',
			bldgrp: '',
			commu: '',
			bplace: '',
			nation: '',
			mothertongue: '',
			stdcat: '',
			religion: '',
			cast: '',
			aadhar: '',
			presentaddr: '',
			permanentaddr: '',
			city: '',
			pincode: '',
			phone: '',
			mobile: '',
			email: '',
			files: [],
			fatname: '',
			fatmob: '',
			fatjob: '',
			fannual: '',
			motname: '',
			motmob: '',
			motjob: '',
			mannual: '',
			grpcode: '',
			attstatus: '',
			sports: '',
			disability: '',
			route: '',
			desti: '',
			sdate: '',
			edate: '',
			hostel: '',
			hroom: '',
			regdate: '',
			vdate: '',
			emisno: '',
			idmark1: '',
			idmark2: '',
			bro1id: '',
			bro2id: '',
			bro3id: '',
			bro1name: '',
			bro2name: '',
			bro3name: '',
			bro1dob: '',
			bro2dob: '',
			bro3dob: '',
			bro1quali: '',
			bro2quali: '',
			bro3quali: '',
			bro1empsta: '',
			bro2empsta: '',
			bro3empsta: '',
			sis1id: '',
			sis2id: '',
			sis3id: '',
			sis1name: '',
			sis2name: '',
			sis3name: '',
			sis1dob: '',
			sis2dob: '',
			sis3dob: '',
			sis1quali: '',
			sis2quali: '',
			sis3quali: '',
			sis1empsta: '',
			sis2empsta: '',
			sis3empsta: '',
			activeTab: '1',
			files1: [],
			files2: [],
			files3: [],
			files4: [],
			files5: [],
			files6: [],
			modal: false,
			modal1: false,
			brochk: '',
			sischk: '',
			data: [],
			sections: [],
			casts: [],
			_redirect: false,
			feetype : [],
			fileimg: GLOBAL.BASE_URL + 'content/admin/assets/img/upload100x100.png'
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.toggle2 = this.toggle2.bind(this);
		this.onBroSubmit = this.onBroSubmit.bind(this);
		this.onSisSubmit = this.onSisSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}

	onClassChange(e) {
		this.setState({ sections: [], cls: e.target.value });
		if (this.state.acyear != '') {
			this.getsec(this.state.acyear, e.target.value);
		}
	}

	getsec(ac, cls) {
		$("#showLoader").show();
		GetData('section/getsecbyclass/' + ac + '/' + cls).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {
				this.setState({ sections: res });
			}
		});
	}

	onCommChange(e) {
		this.setState({ casts: [], commu: e.target.value });
		this.getcas(e.target.value);
	}

	getcas(com) {
		$("#showLoader").show();
		GetData('caste/getcastebycomm/' + com).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {
				this.setState({ casts: res });
			}
		});
	}

	onSisSubmit(e) {

		this.getstddetail();
		this.toggle2();
	}

	onBroSubmit(e) {

		this.getstddetail();
		this.toggle1();
	}

	onBack(e) {

		this.setState({ _redirect: true });
	}

	getstddetail() {
		$("#showLoader").show();
		GetData('student/getstuddet/' + this.state.acyear + '/' + this.state.clsid + '/' + this.state.secid + '/' + this.state.stdid).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {

				if (this.state.brochk == '1') {

					this.setState({
						bro1id: res[0]['id'],
						bro1name: res[0]['stdname'],
						bro1dob: res[0]['dob'],
						bro1quali: res[0]['cls'],
						brochk: '',
						clsid: '',
						secid: '',
						stdid: ''
					});
				}
				if (this.state.brochk == '2') {

					this.setState({
						bro2id: res[0]['id'],
						bro2name: res[0]['stdname'],
						bro2dob: res[0]['dob'],
						bro2quali: res[0]['cls'],
						brochk: '',
						clsid: '',
						secid: '',
						stdid: ''
					});
				}
				if (this.state.brochk == '3') {

					this.setState({
						bro3id: res[0]['id'],
						bro3name: res[0]['stdname'],
						bro3dob: res[0]['dob'],
						bro3quali: res[0]['cls'],
						brochk: '',
						clsid: '',
						secid: '',
						stdid: ''
					});
				}
				if (this.state.sischk == '1') {

					this.setState({
						sis1id: res[0]['id'],
						sis1name: res[0]['stdname'],
						sis1dob: res[0]['dob'],
						sis1quali: res[0]['cls'],
						sischk: '',
						clsid: '',
						secid: '',
						stdid: ''
					});
				}
				if (this.state.sischk == '2') {

					this.setState({
						sis2id: res[0]['id'],
						sis2name: res[0]['stdname'],
						sis2dob: res[0]['dob'],
						sis2quali: res[0]['cls'],
						sischk: '',
						clsid: '',
						secid: '',
						stdid: ''
					});
				}
				if (this.state.sischk == '3') {

					this.setState({
						sis3id: res[0]['id'],
						sis3name: res[0]['stdname'],
						sis3dob: res[0]['dob'],
						sis3quali: res[0]['cls'],
						sischk: '',
						clsid: '',
						secid: '',
						stdid: ''
					});
				}
			}
		});
	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	}

	toggle2(e) {

		this.setState({
			modal2: !this.state.modal2
		});
		this.state.sischk = e.target.value;
	}

	toggle1(e) {

		this.setState({
			modal1: !this.state.modal1
		});
		this.state.brochk = e.target.value;
	}

	onClick(e) {

		document.getElementById("stdform").reset();
	}

	//base64 photo
	getFiles(files) {
		this.setState({ files: files })
	}

	//base64 Certificate 1
	getFiles1(files1) {
		this.setState({ files1: files1 })
	}

	//base64 Certificate 2
	getFiles2(files2) {
		this.setState({ files2: files2 })
	}

	//base64 Certificate 3
	getFiles3(files3) {
		this.setState({ files3: files3 })
	}

	//base64 Certificate 4
	getFiles4(files4) {
		this.setState({ files4: files4 })
	}

	//base64 Certificate 5
	getFiles5(files5) {
		this.setState({ files5: files5 })
	}

	//base64 Certificate 6
	getFiles6(files6) {
		this.setState({ files6: files6 })
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		console.log(this.state);
	}



	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		if (this.state) {
			PostData('student/editstudent', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if (responseJson.status == '1') {
					alert('Student Details Updated Successfully!..');
					this.getdata();
				}
				else {
					this.getdata();
					this.setState({
						_message: 'Invalid Key',
						alertClass: 'alert alert-danger'
					});
				}
			});

		}

	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getacademic();
		this.getclass();
		this.getsection();
		this.getcaste();
		this.getcommunity();
		this.getcategory();
		this.getreligion();
		this.gethostel();
		this.getroom();
		this.getdata();
		this.getfeetype();
	}

	/** get Hostel **/
	getfeetype() {

		GetData('student/getfeetypes').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					feetype: responseJson
				});
			}
		});
	}

	getdata() {
		$("#showLoader").show();
		GetData('student/getstudbyid/' + this.props.match.params.ac + '/' + this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {
				this.setState({
					acyear: res[0]['acyear'],
					regno: res[0]['regno'],
					joindate: res[0]['joindate'],
					regno: res[0]['regno'],
					cls: res[0]['class'],
					section: res[0]['section'],
					ano: res[0]['admissionno'],
					emisno: res[0]['emisno'],
					rollno: res[0]['rollno'],
					type: res[0]['type'],
					stdname: res[0]['studentname'],
					dob: res[0]['dob'],
					gender: res[0]['gender'],
					bldgrp: res[0]['bloodgroup'],
					commu: res[0]['community'],
					cast: res[0]['caste'],
					religion: res[0]['religion'],
					nation: res[0]['nationality'],
					mothertongue: res[0]['mothertongue'],
					bplace: res[0]['birthplace'],
					stdcat: res[0]['category'],
					aadhar: res[0]['aadharno'],
					presentaddr: res[0]['presentaddr'],
					permanentaddr: res[0]['permanentaddr'],
					city: res[0]['city'],
					pincode: res[0]['pincode'],
					country: res[0]['country'],
					region: res[0]['state'],
					mobile: res[0]['mobile'],
					phone: res[0]['phone'],
					email: res[0]['email'],
					grpcode: res[0]['groupcode'],
					attstatus: res[0]['attendance'],
					sports: res[0]['sports'],
					disability: res[0]['disability'],
					idmark1: res[0]['identify1'],
					idmark2: res[0]['identify2'],
					fatname: res[0]['fathername'],
					fatmob: res[0]['fathermob'],
					fatjob: res[0]['fatherjob'],
					fannual: res[0]['fatherannualincome'],
					motname: res[0]['mothername'],
					motmob: res[0]['mothermob'],
					motjob: res[0]['motherjob'],
					mannual: res[0]['motherannualincome'],
					bro1name: res[0]['bro1name'],
					bro1dob: res[0]['bro1dob'],
					bro1quali: res[0]['bro1quali'],
					bro1empsta: res[0]['bro1empstatus'],
					bro2name: res[0]['bro2name'],
					bro2dob: res[0]['bro2dob'],
					bro2quali: res[0]['bro2quali'],
					bro2empsta: res[0]['bro2empstatus'],
					bro3name: res[0]['bro3name'],
					bro3dob: res[0]['bro3dob'],
					bro3quali: res[0]['bro3quali'],
					bro3empsta: res[0]['bro3empstatus'],
					sis1name: res[0]['sis1name'],
					sis1dob: res[0]['sis1dob'],
					sis1quali: res[0]['sis1quali'],
					sis1empsta: res[0]['sis1empstatus'],
					sis2name: res[0]['sis2name'],
					sis2dob: res[0]['sis2dob'],
					sis2quali: res[0]['sis2quali'],
					sis2empsta: res[0]['sis2empstatus'],
					sis3name: res[0]['sis3name'],
					sis3dob: res[0]['sis3dob'],
					sis3quali: res[0]['sis3quali'],
					sis3empsta: res[0]['sis3empstatus'],
					route: res[0]['route'],
					desti: res[0]['destination'],
					tplace: res[0]['transplace'],
					url: res[0]['photo'],
					url1: res[0]['certify1'],
					url2: res[0]['certify2'],
					url3: res[0]['certify3'],
					url4: res[0]['certify4'],
					url5: res[0]['certify5'],
					url6: res[0]['certify6'],
				});
				this.getcas(this.state.commu);
				this.getsec(this.state.acyear, this.state.cls);
			}
		});

	}

	selectCountry(val) {
		this.setState({ country: val });
	}

	selectRegion(val) {
		this.setState({ region: val });
	}

	/** get Hostel **/
	gethostel() {

		GetData('hostel/gethostel').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					hname: responseJson
				});
			}
		});
	}

	/** get Hostel Room **/
	getroom() {

		GetData('hostel/gethostelroom').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					room: responseJson
				});
			}
		});
	}

	/** get Category **/
	getcategory() {

		GetData('student/getcategory').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					cate: responseJson
				});
			}
		});
	}

	/** get Religion **/
	getreligion() {

		GetData('caste/getreligion').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					reli: responseJson
				});
			}
		});
	}

	/** get Class **/
	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	/** get Section **/
	getsection() {

		GetData('section/getsection').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					secs: responseJson
				});
			}
		});
	}

	/** get Academic **/
	getacademic() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					academic: responseJson
				});
			}
		});
	}

	/** get Caste **/
	getcaste() {

		GetData('caste/getcas').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					caste: responseJson
				});
			}
		});
	}

	/** get Community **/
	getcommunity() {

		GetData('caste/getcommunity').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					communi: responseJson
				});
			}
		});
	}


	onBack(e) {
		this.setState({ _redirect: true });
	}

	render() {


		this.state.id = this.props.match.params.id;
		this.state.ac = this.props.match.params.ac;

		var year = this.state.academic;
		var items = this.state.posts;
		var sec = this.state.sections;
		var cas = this.state.casts;
		var com = this.state.communi;
		var cat = this.state.cate;
		var rel = this.state.reli;
		var rc = this.state.rcod;
		var des = this.state.de;
		var hn = this.state.hname;
		var hr = this.state.room;
		const { country, region } = this.state;

		this.gen = [
			{ value: '', name: 'Select Gender' },
			{ value: 'Male', name: 'Male' },
			{ value: 'Female', name: 'Female' }
		];

		if (this.state._redirect) {

			return (<Redirect to='/student/list' />);
		}

		/** set type select box **/
		this.stype = [
			{ value: '', name: 'Select' },
			{ value: 'rte', name: 'RTE' },
			{ value: 'regular', name: 'REGULAR' },
			{ value: 'new', name: 'NEW' }
		];


		/** get Section By Class POPUP **/
		$("#clas1").change(function () {

			var fr = $(this).val();
			var ar = $("#year").val();
			$("#showLoader").show();
			$.get(GLOBAL.BASE_URL + 'section/getsecbyclass/' + ar + '/' + fr, function (o) {
				$("#showLoader").hide();
				$("#secs1").html('');
				$('#secs1')
					.append($("<option></option>")
						.attr("value", '')
						.text(' -Select Section- '));
				$.each(o, function (key, value) {
					$('#secs1')
						.append($("<option></option>")
							.attr("value", value.id)
							.text(value.secs));

				});

			}, 'json');

		});

		/** get Student By Class & Section POPUP **/
		$("#secs1").change(function () {

			var cr = $("#clas1").val();
			var fr = $(this).val();
			var ar = $("#year").val();
			$("#showLoader").show();
			$.get(GLOBAL.BASE_URL + 'student/getstddetails/' + ar + '/' + cr + '/' + fr, function (o) {
				$("#showLoader").hide();
				$("#stud").html('');
				$('#stud')
					.append($("<option></option>")
						.attr("value", '')
						.text(' -Select Student- '));
				$.each(o, function (key, value) {
					$('#stud')
						.append($("<option></option>")
							.attr("value", value.id)
							.text(value.stdname));

				});

			}, 'json');

		});

		if (this.state.url1 != '') {

			$("#c1").show();
		}
		else {
			$("#c1").hide();
		}
		if (this.state.url2 != '') {

			$("#c2").show();
		}
		else {
			$("#c2").hide();
		}
		if (this.state.url3 != '') {

			$("#c3").show();
		}
		else {
			$("#c3").hide();
		}
		if (this.state.url4 != '') {

			$("#c4").show();
		}
		else {
			$("#c4").hide();
		}
		if (this.state.url5 != '') {

			$("#c5").show();
		}
		else {
			$("#c5").hide();
		}
		if (this.state.url6 != '') {

			$("#c6").show();
		}
		else {
			$("#c6").hide();
		}

		return (
			<div>
				<StudentPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Nav tabs>
								<NavItem>
									<NavLink
										className={classnames({ active: this.state.activeTab === '1' })}
										onClick={() => { this.toggle('1'); }}
									>
										Student Details
					</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										className={classnames({ active: this.state.activeTab === '2' })}
										onClick={() => { this.toggle('2'); }}
									>
										Contact Details
					</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										className={classnames({ active: this.state.activeTab === '3' })}
										onClick={() => { this.toggle('3'); }}
									>
										General Details
					</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										className={classnames({ active: this.state.activeTab === '4' })}
										onClick={() => { this.toggle('4'); }}
									>
										Families
					</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										className={classnames({ active: this.state.activeTab === '5' })}
										onClick={() => { this.toggle('5'); }}
									>
										Certificate
					</NavLink>
								</NavItem>
								<button className="btn btn-primary" style={{position : 'absolute',right : '34px'}} type="button" onClick={this.onBack.bind(this)} >Back</button>
							</Nav>
							
							<form action="" method="post" role="form" id="stdform" encType="multipart/form-data" onSubmit={this.onSubmit} >
								<TabContent activeTab={this.state.activeTab}>
									<TabPane tabId="1">
										<Row>
											<Col md="12">
												<Card>
													<CardHeader className="card-header-inner">
														<strong>Student Admission</strong>
													</CardHeader>
													<CardBody>
														<h5>Official Details</h5><hr className="line"></hr>
														<Row>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Academic Year <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<select name="acyear" onChange={this.onChange} className="form-control" required id="year" value={this.state.acyear} disabled>
																		<option value="">Select Academic Year</option>
																		{
																			year.map(function (item) {
																				return <option value={item.id}>{item.startyear} - {item.endyear}</option>;
																			})
																		}
																	</select>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Admission Number <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="number" name="regno" required onChange={this.onChange} value={this.state.regno} disabled />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Joining Date </Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="date" name="joindate" onChange={this.onChange} value={this.state.joindate} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Class <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<select name="cls" onChange={this.onClassChange.bind(this)} className="form-control" id="clas" required value={this.state.cls}>
																		<option value="">Select Class</option>
																		{
																			items.map(function (item) {
																				return <option value={item.id}>{item.class}</option>;
																			})
																		}
																	</select>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Section <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<select name="section" onChange={this.onChange} className="form-control" required id="secs" value={this.state.section}>
																		<option value="">Select Section</option>
																		{
																			sec.map(function (item) {
																				return <option value={item.id}>{item.secs}</option>;
																			})
																		}
																	</select>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Type <span className="text-danger"></span></Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<select name="type" className="form-control" onChange={this.onChange} value={this.state.type}>
																		{this.state.feetype.map((e, key) => {
																			return <option key={key} value={e.categoryname}>{e.displayname}</option>;
																		})}
																	</select>
																</FormGroup>
															</Col>
															{/*}
							  <Col md="2">
								<FormGroup>
								  <Label htmlFor="name">Admission Number <span className="text-danger"></span></Label>
								</FormGroup>
							   </Col>
							  <Col md="2">
								<FormGroup>
								  <Input type="text" name="ano" onChange={this.onChange} value={this.state.ano}/>
								</FormGroup>
								</Col>*/}
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">EMIS No <span className="text-danger"></span></Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="text" name="emisno" onChange={this.onChange} value={this.state.emisno} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Roll No <span className="text-danger"></span></Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="text" name="rollno" id="rollno" onChange={this.onChange} value={this.state.rollno} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Category </Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<select name="stdcat" className="form-control" onChange={this.onChange} value={this.state.stdcat}>
																		<option value="">Select Category</option>
																		{
																			cat.map(function (item) {
																				return <option value={item.id}>{item.category}</option>;
																			})
																		}
																	</select>
																</FormGroup>
															</Col>
														</Row>
														<h5>Personal Details</h5><hr className="line"></hr>
														<Row>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Student Name <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="text" name="stdname" required onChange={this.onChange} value={this.state.stdname} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Date of Birth <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="date" name="dob" onChange={this.onChange} value={this.state.dob} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Gender <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<select name="gender" id="gender" className="form-control" onChange={this.onChange} required value={this.state.gender}>
																		{this.gen.map((e, key) => {
																			return <option key={key} value={e.value}>{e.name}</option>;
																		})}
																	</select>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Blood Group</Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<select name="bldgrp" className="form-control" onChange={this.onChange} value={this.state.bldgrp}>
																		<option value="">Blood Group</option>
																		<option value="A+">A+</option>
																		<option value="B+">B+</option>
																		<option value="A-">A-</option>
																		<option value="B-">B-</option>
																		<option value="B1+">B1+</option>
																		<option value="O+">O+</option>
																		<option value="O-">O-</option>
																		<option value="AB+">AB+</option>
																		<option value="AB-">AB-</option>
																		<option value="A1+">A1+</option>
																		<option value="A1-">A1-</option>
																		<option value="A2+">A2+</option>
																		<option value="A2-">A2-</option>
																		<option value="A1B+">A1B+</option>
																		<option value="A1B-">A1B-</option>
																		<option value="A2B+">A2B+</option>
																		<option value="A2B-">A2B-</option>
																	</select>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Community</Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<select name="commu" onChange={this.onCommChange.bind(this)} className="form-control" id="communi" value={this.state.commu}>
																		<option value="">Select Community</option>
																		{
																			com.map(function (item) {
																				return <option value={item.id}>{item.community}</option>;
																			})
																		}
																	</select>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Caste</Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<select name="cast" onChange={this.onChange} className="form-control" id="caste" value={this.state.cast}>
																		<option value="">Select Caste</option>
																		{
																			cas.map(function (item) {
																				return <option value={item.id}>{item.caste}</option>;
																			})
																		}
																	</select>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Religion</Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<select name="religion" className="form-control" onChange={this.onChange} value={this.state.religion}>
																		<option value="">Select Religion</option>
																		{
																			rel.map(function (item) {
																				return <option value={item.id}>{item.religion}</option>;
																			})
																		}
																	</select>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Nationality</Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="text" name="nation" id="nation" onChange={this.onChange} value={this.state.nation} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Mother Tongue </Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="text" name="mothertongue" id="mothertongue" onChange={this.onChange} value={this.state.mothertongue} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Birth Place</Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="text" name="bplace" onChange={this.onChange} value={this.state.bplace} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Aadhar Number </Label>
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="text" name="aadhar" onChange={this.onChange} value={this.state.aadhar} />
																</FormGroup>
															</Col>
														</Row>
													</CardBody>
												</Card>
											</Col>
										</Row>
									</TabPane>
									<TabPane tabId="2">
										<Row>
											<Col md="12">
												<h5>Contact Details</h5><hr className="line"></hr>
												<Row>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">Present Address <span className="text-danger">*</span></Label>
															<Input type="textarea" name="presentaddr" id="presentaddr" required onChange={this.onChange} value={this.state.presentaddr} />
														</FormGroup>
													</Col>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">Permanent Address</Label>
															<Input type="textarea" name="permanentaddr" onChange={this.onChange} value={this.state.permanentaddr} />
														</FormGroup>
													</Col>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">City </Label>
															<Input type="text" name="city" onChange={this.onChange} value={this.state.city} />
														</FormGroup>
													</Col>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">Pincode </Label>
															<Input type="number" name="pincode" onChange={this.onChange} value={this.state.pincode} />
														</FormGroup>
													</Col>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">Country <span className="text-danger">*</span></Label>
															<CountryDropdown value={country} onChange={(val) => this.selectCountry(val)} id="con" name="country" />
														</FormGroup>
													</Col>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">State <span className="text-danger">*</span></Label>
															<RegionDropdown country={country} value={region} onChange={(val) => this.selectRegion(val)} id="con" name="state" />
														</FormGroup>
													</Col>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">Mobile <span className="text-danger">*</span></Label>
															<Input type="number" name="mobile" onChange={this.onChange} value={this.state.mobile} />
														</FormGroup>
													</Col>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">Phone </Label>
															<Input type="number" name="phone" onChange={this.onChange} value={this.state.phone} />
														</FormGroup>
													</Col>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">Email</Label>
															<Input type="email" name="email" onChange={this.onChange} value={this.state.email} />
														</FormGroup>
													</Col>
													<Col md="3">
														<Card>
															<CardBody>
																<img src={this.state.url} id="studphoto" />
															</CardBody>
														</Card>
													</Col>
													<Col md="3">
														<FormGroup>
															<FileBase64 onDone={this.getFiles.bind(this)} required />
														</FormGroup>
													</Col>
												</Row>
											</Col>
										</Row>
									</TabPane>
									<TabPane tabId="3">
										<Row>
											<Col md="12">
												<h5>General Details</h5><hr className="line"></hr>
												<Row>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">Group Code (for HSC only) </Label>
															<Input type="text" name="grpcode" onChange={this.onChange} value={this.state.grpcode} />
														</FormGroup>
													</Col>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">Attendance Status </Label>
															<Input type="text" name="attstatus" onChange={this.onChange} value={this.state.attstatus} />
														</FormGroup>
													</Col>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">Sports Participation </Label>
															<Input type="text" name="sports" onChange={this.onChange} value={this.state.sports} />
														</FormGroup>
													</Col>
													<Col md="6">
														<FormGroup>
															<Label htmlFor="name">If Differently - abled type of disability </Label>
															<Input type="text" name="disability" onChange={this.onChange} value={this.state.disability} />
														</FormGroup>
													</Col>
												</Row>
												<h5>Personal Marks of Identification</h5><hr className="line"></hr>
												<Row>
													<Col md="1">
														<FormGroup className="pd-left">
															(1)
								</FormGroup>
													</Col>
													<Col md="11">
														<FormGroup>
															<Input type="text" name="idmark1" onChange={this.onChange} value={this.state.idmark1} />
														</FormGroup>
													</Col>
													<Col md="1">
														<FormGroup className="pd-left">
															(2)
								</FormGroup>
													</Col>
													<Col md="11">
														<FormGroup>
															<Input type="text" name="idmark2" onChange={this.onChange} value={this.state.idmark2} />
														</FormGroup>
													</Col>
												</Row>
											</Col>
										</Row>
									</TabPane>
									<TabPane tabId="4">
										<Row>
											<Col md="12">
												<Card>
													<CardHeader className="card-header-inner">
														<strong>Family Details</strong>
													</CardHeader>
													<CardBody>
														<h5>Father Details</h5><hr className="line"></hr>
														<Row>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Name <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="fatname" onChange={this.onChange} value={this.state.fatname} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Mobile </Label>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="number" name="fatmob" onChange={this.onChange} value={this.state.fatmob} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Job </Label>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="fatjob" onChange={this.onChange} value={this.state.fatjob} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Annual Income </Label>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="fannual" onChange={this.onChange} value={this.state.fannual} />
																</FormGroup>
															</Col>
														</Row>
														<h5>Mother Details</h5><hr className="line"></hr>
														<Row>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Name <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="motname" onChange={this.onChange} value={this.state.motname} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Mobile </Label>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="number" name="motmob" onChange={this.onChange} value={this.state.motmob} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Job </Label>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="motjob" onChange={this.onChange} value={this.state.motjob} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Annual Income</Label>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="mannual" onChange={this.onChange} value={this.state.mannual} />
																</FormGroup>
															</Col>
														</Row>
														<h5>Brothers Details</h5><hr className="line"></hr>
														<Row>
															<Col md="1" className="sscl">
																<FormGroup>
																	<Label htmlFor="name"></Label>
																	<input type="checkbox" name="bro1" id="brother1" value="1" onClick={this.toggle1} />
																</FormGroup>
															</Col>
															<Col md="3" className="samescl">
																<FormGroup>
																	<Label htmlFor="name">Name <span className="text-danger"></span></Label>
																	<Input type="hidden" value={this.state.bro1id} />
																	<Input type="text" name="bro1name" onChange={this.onChange} value={this.state.bro1name} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Dob <span className="text-danger"></span></Label>
																	<Input type="date" name="bro1dob" onChange={this.onChange} value={this.state.bro1dob} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Qualification <span className="text-danger"></span></Label>
																	<Input type="text" name="bro1quali" onChange={this.onChange} value={this.state.bro1quali} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Employed Status <span className="text-danger"></span></Label>
																	<Input type="text" name="bro1empsta" onChange={this.onChange} />
																</FormGroup>
															</Col>
															<Modal isOpen={this.state.modal1} toggle={this.toggle1} className={this.props.className} id="editdes">
																<ModalHeader toggle={this.toggle1}>Select</ModalHeader>
																<ModalBody>
																	<Row>
																		<Col md="3">
																			<FormGroup>
																				<Label htmlFor="name">Class <span className="text-danger">*</span></Label>
																			</FormGroup>
																		</Col>
																		<Col md="9">
																			<FormGroup>
																				<select name="clsid" onChange={this.onChange} className="form-control" id="clas1">
																					<option value="">Select Class</option>
																					{
																						items.map(function (item) {
																							return <option value={item.id}>{item.class}</option>;
																						})
																					}
																				</select>
																			</FormGroup>
																		</Col>
																		<Col md="3">
																			<FormGroup>
																				<Label htmlFor="name">Section <span className="text-danger">*</span></Label>
																			</FormGroup>
																		</Col>
																		<Col md="9">
																			<FormGroup>
																				<select name="secid" onChange={this.onChange} className="form-control" id="secs1">

																				</select>
																			</FormGroup>
																		</Col>
																		<Col md="3">
																			<FormGroup>
																				<Label htmlFor="name">Student <span className="text-danger">*</span></Label>
																			</FormGroup>
																		</Col>
																		<Col md="9">
																			<FormGroup>
																				<select name="stdid" onChange={this.onChange} className="form-control" id="stud">

																				</select>
																			</FormGroup>
																		</Col>
																	</Row>
																</ModalBody>
																<ModalFooter>
																	<Button type="submit" size="sm" color="primary" onClick={this.onBroSubmit}><i className="fa fa-dot-circle-o"></i> Add</Button>
																</ModalFooter>
															</Modal>
														</Row>
														<Row>
															<Col md="1">
																<FormGroup>
																	<input type="checkbox" name="bro2" id="brother2" value="2" onClick={this.toggle1} />
																</FormGroup>
															</Col>
															<Col md="3" className="samescl">
																<FormGroup>
																	<Input type="hidden" value={this.state.bro2id} />
																	<Input type="text" name="bro2name" onChange={this.onChange} value={this.state.bro2name} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="date" name="bro2dob" onChange={this.onChange} value={this.state.bro2dob} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="bro2quali" onChange={this.onChange} value={this.state.bro2quali} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="bro2empsta" onChange={this.onChange} />
																</FormGroup>
															</Col>
														</Row>
														<Row>
															<Col md="1">
																<FormGroup>
																	<input type="checkbox" name="bro3" id="brother3" value="3" onClick={this.toggle1} />
																</FormGroup>
															</Col>
															<Col md="3" className="samescl">
																<FormGroup>
																	<Input type="hidden" value={this.state.bro3id} />
																	<Input type="text" name="bro3name" onChange={this.onChange} value={this.state.bro3name} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="date" name="bro3dob" onChange={this.onChange} value={this.state.bro3dob} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="bro3quali" onChange={this.onChange} value={this.state.bro3quali} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="bro3empsta" onChange={this.onChange} />
																</FormGroup>
															</Col>
														</Row>
														<h5>Sisters Details</h5><hr className="line"></hr>
														<Row>
															<Col md="1" className="sscl">
																<FormGroup>
																	<Label htmlFor="name"></Label>
																	<input type="checkbox" name="sis1" id="sister1" value="1" onClick={this.toggle2} />
																</FormGroup>
															</Col>
															<Col md="3" className="samescl">
																<FormGroup>
																	<Label htmlFor="name">Name <span className="text-danger"></span></Label>
																	<Input type="hidden" value={this.state.sis1id} />
																	<Input type="text" name="sis1name" onChange={this.onChange} value={this.state.sis1name} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Dob <span className="text-danger"></span></Label>
																	<Input type="date" name="sis1dob" onChange={this.onChange} value={this.state.sis1dob} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Qualification <span className="text-danger"></span></Label>
																	<Input type="text" name="sis1quali" onChange={this.onChange} value={this.state.sis1quali} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Employed Status <span className="text-danger"></span></Label>
																	<Input type="text" name="sis1empsta" onChange={this.onChange} />
																</FormGroup>
															</Col>
															<Modal isOpen={this.state.modal2} toggle={this.toggle2} className={this.props.className} id="editdes">
																<ModalHeader toggle={this.toggle2}>Select</ModalHeader>
																<ModalBody>
																	<Row>
																		<Col md="3">
																			<FormGroup>
																				<Label htmlFor="name">Class <span className="text-danger">*</span></Label>
																			</FormGroup>
																		</Col>
																		<Col md="9">
																			<FormGroup>
																				<select name="clsid" onChange={this.onChange} className="form-control" id="clas1" required>
																					<option value="">Select Class</option>
																					{
																						items.map(function (item) {
																							return <option value={item.id}>{item.class}</option>;
																						})
																					}
																				</select>
																			</FormGroup>
																		</Col>
																		<Col md="3">
																			<FormGroup>
																				<Label htmlFor="name">Section <span className="text-danger">*</span></Label>
																			</FormGroup>
																		</Col>
																		<Col md="9">
																			<FormGroup>
																				<select name="secid" onChange={this.onChange} className="form-control" required id="secs1">

																				</select>
																			</FormGroup>
																		</Col>
																		<Col md="3">
																			<FormGroup>
																				<Label htmlFor="name">Student <span className="text-danger">*</span></Label>
																			</FormGroup>
																		</Col>
																		<Col md="9">
																			<FormGroup>
																				<select name="stdid" onChange={this.onChange} className="form-control" required id="stud">

																				</select>
																			</FormGroup>
																		</Col>
																	</Row>
																</ModalBody>
																<ModalFooter>
																	<Button type="submit" size="sm" color="primary" onClick={this.onSisSubmit}><i className="fa fa-dot-circle-o"></i> Add</Button>
																</ModalFooter>
															</Modal>
														</Row>
														<Row>
															<Col md="1">
																<FormGroup>
																	<input type="checkbox" name="sis2" id="sister2" value="2" onClick={this.toggle2} />
																</FormGroup>
															</Col>
															<Col md="3" className="samescl">
																<FormGroup>
																	<Input type="hidden" value={this.state.sis2id} />
																	<Input type="text" name="sis2name" onChange={this.onChange} value={this.state.sis2name} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="date" name="sis2dob" onChange={this.onChange} value={this.state.sis2dob} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="sis2quali" onChange={this.onChange} value={this.state.sis2quali} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="sis2empsta" onChange={this.onChange} />
																</FormGroup>
															</Col>
														</Row>
														<Row>
															<Col md="1">
																<FormGroup>
																	<input type="checkbox" name="sis3" id="sister3" value="3" onClick={this.toggle2} />
																</FormGroup>
															</Col>
															<Col md="3" className="samescl">
																<FormGroup>
																	<Input type="hidden" value={this.state.sis3id} />
																	<Input type="text" name="sis3name" onChange={this.onChange} value={this.state.sis3name} />
																</FormGroup>
															</Col>
															<Col md="2">
																<FormGroup>
																	<Input type="date" name="sis3dob" onChange={this.onChange} value={this.state.sis3dob} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="sis3quali" onChange={this.onChange} value={this.state.sis3quali} />
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Input type="text" name="sis3empsta" onChange={this.onChange} />
																</FormGroup>
															</Col>
														</Row>
													</CardBody>
												</Card>
											</Col>
										</Row>
									</TabPane>
									<TabPane tabId="5">
										<Row>
											<Col md="12">
												<Card>
													<CardHeader className="card-header-inner">
														<strong>Certificates Upload</strong>
													</CardHeader>
													<CardBody>
														<Row>
															<Col md="4">
																<FormGroup>
																	<Label>Community Certificate</Label>
																	<Row id="c1">
																		<Col md="3">
																			<a target="_blank" href={this.state.url1}>
																				<img src={this.state.fileimg} />
																			</a>
																		</Col>
																	</Row>
																	<FileBase64 onDone={this.getFiles1.bind(this)} />
																</FormGroup>
															</Col>
															<Col md="4">
																<FormGroup>
																	<Label>Transfer Certificate</Label>
																	<Row id="c2">
																		<Col md="3">
																			<a target="_blank" href={this.state.url2}>
																				<img src={this.state.fileimg} />
																			</a>
																		</Col>
																	</Row>
																	<FileBase64 onDone={this.getFiles2.bind(this)} />
																</FormGroup>
															</Col>
															<Col md="4">
																<FormGroup>
																	<Label>Marksheet&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Label>
																	<Row id="c3">
																		<Col md="3">
																			<a target="_blank" href={this.state.url3}>
																				<img src={this.state.fileimg} />
																			</a>
																		</Col>
																	</Row>
																	<FileBase64 onDone={this.getFiles3.bind(this)} />
																</FormGroup>
															</Col>
														</Row>
														<h5>Others</h5><hr className="line"></hr>
														<Row>
															<Col md="4">
																<FormGroup>
																	<Row id="c4">
																		<Col md="3">
																			<a target="_blank" href={this.state.url4}>
																				<img src={this.state.fileimg} />
																			</a>
																		</Col>
																	</Row>
																	<FileBase64 onDone={this.getFiles4.bind(this)} />
																</FormGroup>
															</Col>
															<Col md="4">
																<FormGroup>
																	<Row id="c5">
																		<Col md="3">
																			<a target="_blank" href={this.state.url5}>
																				<img src={this.state.fileimg} />
																			</a>
																		</Col>
																	</Row>
																	<FileBase64 onDone={this.getFiles5.bind(this)} />
																</FormGroup>
															</Col>
															<Col md="4">
																<FormGroup>
																	<Row id="c6">
																		<Col md="3">
																			<a target="_blank" href={this.state.url6}>
																				<img src={this.state.fileimg} />
																			</a>
																		</Col>
																	</Row>
																	<FileBase64 onDone={this.getFiles6.bind(this)} />
																</FormGroup>
															</Col>
														</Row>
													</CardBody>
												</Card>
											</Col>
										</Row>
									</TabPane>
								</TabContent>
								<Card>
									<CardFooter>
										<Button type="submit" size="md" color="primary" className="btn-right"><i className="fa fa-dot-circle-o"></i> Update</Button>
									</CardFooter>
								</Card>
							</form>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default EditStudent;


// WEBPACK FOOTER //
// ./src/student/Admission/EditStudent.js